'use client';

import React from 'react';
import { useParams } from 'next/navigation';

export const normalize = (content: string, locale: string) => {
  return (typeof content === 'string' ? content : content[locale]) ?? '';
};

export interface TypographyProps {
  children?: string;
}

const Typography: React.FC<TypographyProps> = ({ children }) => {
  const params = useParams();

  const locale = params?.locale as string;

  const normalized = children && normalize(children, locale);

  return <>{normalized}</>;
};

export default Typography;
